import { PetType } from 'constants/pet-type';
import { ActivePetProfile } from 'stores/pet-profile-new/types';
import { PetProfile } from 'types/pet-profile';

interface ReconcileActivePetProfile {
  activePetProfile: ActivePetProfile;
  customerPets: PetProfile[];
}

// keeps the active id when it still points to one of the profiles, otherwise the first
const reconcileId = (activeId: string, profilesOfType: PetProfile[]): string => {
  const isActiveIdValid = profilesOfType.some((profile) => profile.id === activeId);
  return isActiveIdValid ? activeId : profilesOfType[0].id;
};

/**
 * Repairs dangling active profile ids: if the active id is not among the customer's
 * profiles (e.g. a guest profile id after login), the first customer profile of the
 * same pet type becomes active instead. Pet types with no profile keep their current id.
 */
export const reconcileActivePetProfile = ({
  activePetProfile,
  customerPets,
}: ReconcileActivePetProfile): ActivePetProfile => {
  const customerDogs = customerPets.filter((profile) => profile.petType === PetType.Dog);
  const customerCats = customerPets.filter((profile) => profile.petType === PetType.Cat);

  // nothing to reconcile against when a pet type has no profile, so keep the current id
  const dogId = customerDogs.length
    ? reconcileId(activePetProfile[PetType.Dog], customerDogs)
    : activePetProfile[PetType.Dog];

  const catId = customerCats.length
    ? reconcileId(activePetProfile[PetType.Cat], customerCats)
    : activePetProfile[PetType.Cat];

  const isUnchanged =
    dogId === activePetProfile[PetType.Dog] && catId === activePetProfile[PetType.Cat];

  return isUnchanged ? activePetProfile : { [PetType.Dog]: dogId, [PetType.Cat]: catId };
};
